function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgCpu = function SvgCpu(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M58.483,88.552H21.12C9.474,88.552,0,98.027,0,109.672v16.264c0,11.646,9.474,21.12,21.12,21.12 h37.363V88.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M58.483,180.683H21.12c-11.646,0-21.12,9.475-21.12,21.12v16.264c0,11.646,9.474,21.12,21.12,21.12 h37.363V180.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M58.483,272.813H21.12c-11.646,0-21.12,9.475-21.12,21.12v16.264c0,11.646,9.474,21.12,21.12,21.12 h37.363V272.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M58.483,364.943H21.12c-11.646,0-21.12,9.475-21.12,21.12v16.264c0,11.646,9.474,21.12,21.12,21.12 h37.363V364.943z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M88.553,453.517L88.553,453.517v37.363c0,11.646,9.474,21.12,21.12,21.12h16.264 c11.646,0,21.12-9.475,21.12-21.12v-37.363l0,0H88.553z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M180.683,453.517L180.683,453.517v37.363c0,11.646,9.474,21.12,21.12,21.12h16.264 c11.646,0,21.12-9.475,21.12-21.12v-37.363l0,0H180.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M272.813,453.517L272.813,453.517v37.363c0,11.646,9.474,21.12,21.12,21.12h16.264 c11.646,0,21.12-9.475,21.12-21.12v-37.363l0,0H272.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M364.943,453.517L364.943,453.517v37.363c0,11.646,9.474,21.12,21.12,21.12h16.264 c11.646,0,21.12-9.475,21.12-21.12v-37.363l0,0H364.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D3A"
    },
    d: "M490.88,88.552h-37.363v58.505h37.363c11.646,0,21.12-9.475,21.12-21.12v-16.264 C512,98.027,502.526,88.552,490.88,88.552z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D3A"
    },
    d: "M490.88,180.683h-37.363v58.504h37.363c11.646,0,21.12-9.475,21.12-21.12v-16.264 C512,190.157,502.526,180.683,490.88,180.683z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D3A"
    },
    d: "M490.88,272.813h-37.363v58.504h37.363c11.646,0,21.12-9.475,21.12-21.12v-16.264 C512,282.288,502.526,272.813,490.88,272.813z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF6D3A"
    },
    d: "M490.88,364.943h-37.363v58.505h37.363c11.646,0,21.12-9.475,21.12-21.12v-16.264 C512,374.418,502.526,364.943,490.88,364.943z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M147.057,58.483L147.057,58.483V21.12c0-11.646-9.474-21.12-21.12-21.12h-16.264 c-11.646,0-21.12,9.475-21.12,21.12v37.363l0,0H147.057z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M239.187,58.483L239.187,58.483V21.12c0-11.646-9.474-21.12-21.12-21.12h-16.264 c-11.646,0-21.12,9.475-21.12,21.12v37.363l0,0H239.187z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M331.317,58.483L331.317,58.483V21.12c0-11.646-9.474-21.12-21.12-21.12h-16.264 c-11.646,0-21.12,9.475-21.12,21.12v37.363l0,0H331.317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M423.447,58.483L423.447,58.483V21.12c0-11.646-9.474-21.12-21.12-21.12h-16.264 c-11.646,0-21.12,9.475-21.12,21.12v37.363l0,0H423.447z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D5872"
    },
    d: "M433.22,456.517H78.78c-12.867,0-23.297-10.43-23.297-23.297V78.78 c0-12.867,10.43-23.297,23.297-23.297h354.44c12.866,0,23.297,10.43,23.297,23.297v354.44 C456.517,446.086,446.086,456.517,433.22,456.517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D4859"
    },
    d: "M433.22,55.483h-38.644c12.866,0,23.297,10.43,23.297,23.297v354.44 c0,12.866-10.43,23.297-23.297,23.297h38.644c12.866,0,23.297-10.43,23.297-23.297V78.78 C456.517,65.914,446.086,55.483,433.22,55.483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFB124"
    },
    d: "M381.525,299.639v-153.68c0-8.552-6.932-15.484-15.484-15.484H145.959 c-8.552,0-15.484,6.932-15.484,15.484V366.04c0,8.552,6.932,15.484,15.484,15.484h153.68c4.107,0,8.045-1.631,10.949-4.535 l66.402-66.402C379.893,307.684,381.525,303.746,381.525,299.639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF901E"
    },
    d: "M366.041,130.475h-23.16v144.882c0,4.107-1.631,8.045-4.535,10.949l-66.402,66.402 c-2.904,2.904-6.842,4.535-10.949,4.535h-130.52v8.798c0,8.552,6.932,15.484,15.484,15.484h153.68c4.107,0,8.045-1.631,10.949-4.535 l66.402-66.402c2.904-2.904,4.535-6.842,4.535-10.949v-153.68C381.525,137.408,374.592,130.475,366.041,130.475z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D5872"
    },
    d: "M179.781,268.847v-25.609c0-18.276,7.476-27.414,22.429-27.414c3.151,0,5.952,0.423,8.4,1.268 c2.45,0.845,4.505,2.013,6.166,3.502c1.661,1.49,3.029,3.324,4.103,5.5c1.074,2.177,1.847,4.54,2.321,7.09 c0.472,2.55,0.709,5.357,0.709,8.422v4.707c0,1.079-0.874,1.953-1.953,1.953H210.48c-1.079,0-1.953-0.874-1.953-1.953v-5.18 c0-1.403-0.029-2.613-0.086-3.63c-0.058-1.017-0.208-2.176-0.451-3.481c-0.244-1.303-0.574-2.363-0.989-3.179 c-0.416-0.816-1.031-1.511-1.847-2.084c-0.817-0.573-1.798-0.86-2.944-0.86c-4.526,0-6.788,3.81-6.788,11.429v33.386 c0,7.591,2.263,11.386,6.788,11.386c1.346,0,2.478-0.387,3.395-1.16c0.917-0.774,1.575-1.869,1.976-3.287s0.674-2.807,0.817-4.168 c0.143-1.36,0.214-2.915,0.214-4.662v-5.996c0-1.079,0.874-1.953,1.953-1.953h11.391c1.079,0,1.953,0.874,1.953,1.953v4.578 c-0.058,2.951-0.301,5.672-0.731,8.164c-0.43,2.492-1.16,4.913-2.192,7.261c-1.031,2.349-2.342,4.333-3.932,5.951 c-1.589,1.619-3.645,2.922-6.165,3.91c-2.521,0.989-5.415,1.482-8.68,1.482c-3.351,0-6.324-0.48-8.916-1.439 c-2.593-0.96-4.726-2.249-6.402-3.867s-3.058-3.609-4.146-5.972c-1.089-2.363-1.855-4.848-2.299-7.455 C180.003,274.835,179.781,271.97,179.781,268.847z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D5872"
    },
    d: "M237.374,292.718v-73.436c0-1.079,0.874-1.953,1.953-1.953h16.738c6.731,0,11.63,1.877,14.695,5.629 c3.065,3.753,4.597,9.181,4.597,16.285c0,3.495-0.337,6.531-1.009,9.109c-0.674,2.578-1.611,4.705-2.814,6.381 s-2.75,3.022-4.64,4.039c-1.891,1.017-3.939,1.733-6.145,2.148c-1.718,0.324-3.644,0.53-5.778,0.619 c-1.043,0.043-1.87,0.904-1.87,1.948v29.231c0,1.079-0.874,1.953-1.953,1.953h-11.819 C238.249,294.671,237.374,293.797,237.374,292.718z M253.143,248.457c0,1.174,1.034,2.117,2.194,1.939 c0.006-0.001,0.013-0.002,0.019-0.003c0.369-0.057,0.713-0.12,1.03-0.187c0.908-0.191,1.738-0.646,2.405-1.291 c0.179-0.173,0.337-0.332,0.474-0.478c0.243-0.258,0.452-0.68,0.623-1.268c0.172-0.587,0.301-1.066,0.386-1.439 c0.086-0.372,0.151-0.973,0.194-1.805c0.043-0.831,0.065-1.497,0.065-1.998s0-1.282,0-2.342c0-0.286,0-0.501,0-0.645 c0-1.117-0.008-1.962-0.022-2.535s-0.065-1.303-0.15-2.191c-0.086-0.888-0.222-1.554-0.408-1.998 c-0.187-0.444-0.459-0.952-0.817-1.525c-0.359-0.573-0.795-0.989-1.31-1.246c-0.516-0.258-1.168-0.487-1.955-0.687 c-0.118-0.03-0.238-0.058-0.361-0.083c-1.218-0.252-2.368,0.671-2.368,1.914L253.143,248.457L253.143,248.457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2D5872"
    },
    d: "M287.103,265.926v-46.644c0-1.079,0.874-1.953,1.953-1.953h11.733c1.079,0,1.953,0.874,1.953,1.953 v46.171c0,2.75,0.014,4.748,0.044,5.994c0.028,1.246,0.1,2.765,0.214,4.555c0.114,1.79,0.315,3.044,0.602,3.759 c0.287,0.716,0.68,1.49,1.181,2.32c0.501,0.831,1.153,1.375,1.955,1.633c0.802,0.258,1.776,0.387,2.922,0.387 c1.145,0,2.12-0.129,2.921-0.387c0.802-0.258,1.454-0.795,1.955-1.611c0.501-0.816,0.895-1.583,1.181-2.299 c0.287-0.716,0.487-1.955,0.602-3.717c0.115-1.762,0.186-3.251,0.215-4.469c0.027-1.217,0.043-3.186,0.043-5.908 c0-0.114,0-0.2,0-0.258v-46.171c0-1.079,0.874-1.953,1.953-1.953h11.734c1.079,0,1.953,0.874,1.953,1.953v46.644 c0,2.464-0.072,4.698-0.215,6.703s-0.416,4.082-0.816,6.23c-0.401,2.148-0.945,4.047-1.633,5.693 c-0.688,1.648-1.604,3.223-2.75,4.727s-2.5,2.743-4.061,3.717c-1.562,0.974-3.445,1.747-5.651,2.32s-4.683,0.859-7.433,0.859 s-5.229-0.287-7.434-0.859c-2.206-0.574-4.082-1.346-5.629-2.32s-2.894-2.213-4.039-3.717c-1.146-1.504-2.063-3.079-2.75-4.727 c-0.688-1.647-1.24-3.545-1.655-5.693c-0.416-2.148-0.694-4.225-0.838-6.23C287.174,270.624,287.103,268.39,287.103,265.926z"
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCpu, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cpu.b88c2928.svg";
export { ForwardRef as ReactComponent };